import { createAction } from '@reduxjs/toolkit'

import { SIM, LatestJobRun } from 'redux/reducers/DataPlatform/SIM'

export const getSIM = createAction('get_sim')
export const getSIMSuccess = createAction<SIM>('get_sim_success')
export const getSIMFailed = createAction<{ notFound: boolean }>(
  'get_sim_failed'
)

export const startSIMImport = createAction('start_sim_import')
export const startSIMImportSuccess = createAction<LatestJobRun>(
  'start_sim_import_success'
)
export const startSIMImportFailed = createAction('start_sim_import_failed')

export const pollSIMImportSuccess = createAction<LatestJobRun>(
  'poll_sim_import_success'
)

export const deleteCustomSIMSuccess = createAction('delete_custom_sim_success')
